<template>
  <div class="row" v-if="canRead">
    <div class="card advanced-search width-100">
      <div class="card-body" style="padding: 15px;">
        <div class="form-group row">
          <div class="col-md-6">
            <label>Customer Name</label>
            <v-select
              name="selectedClient"
              v-model="selectedClient"
              placeholder="Search for a Company"
              label="name"
              value="name"
              @input="setClient"
              :options="autocompleteResults">
            </v-select>
          </div>
          <div class="col-md-4">
            <label>Invoice Number</label>
            <el-input type="search"
                      name="invoiceNumber"
                      placeholder="Invoice Number"
                      clearable
                      @keyup.enter.native="searchSubmit"
                      v-model="query.refNumber"
                      :disabled="query.refNumberIsNull" />
          </div>
          <div class="col-md-2" style="padding-left: 0;">
            <label>Missing Invoice Number</label>
            <p-switch v-model="query.refNumberIsNull" type="primary" @input="maybeClearInvoiceNumber" on-text="YES" off-text="NO" style="display:block"></p-switch>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" :disabled="isSearchButtonDisabled" class="btn btn-fill btn-info btn-company-search pull-right" @click="searchSubmit" style="margin-right: 15px;">
          Search
        </button>
        <button type="button" :disabled="isSearchButtonDisabled" class="btn btn-fill btn-info btn-company-search btn-clear pull-right" @click="clear">
          Clear
        </button>
      </div>
    </div><!-- end card -->
    <div class="col-md-12 card">
      <div class="card-body row">
        <div class="col-sm-12">
          <el-table class="wrap-whole-words table-striped indexed-table-column-width"
                    :data="tableData"
                    style="width: 100%"
                    :max-height="tableHeight(300)">
            <el-table-column
              :width="indexColumnWidth"
              align="center"
              label="#"
              type="index">
            </el-table-column>
            <el-table-column
              min-width="200"
              :sortable="true"
              sort-by="_source.name"
              label="Name">
              <template v-slot="props">
                <span class="invisible">{{props.row.id}}</span>
                <a href="#" @click.prevent="viewInvoiceDetails(props.row)">{{props.row.customerName}}</a>
              </template>
            </el-table-column>
            <el-table-column
              min-width="200"
              label="Invoice Number">
              <template v-slot="props">
                {{props.row.refNumber}}
              </template>
            </el-table-column>
            <el-table-column
              min-width="200"
              label="Date">
              <template v-slot="props">
                {{props.row.txnDate | formatDate}}
              </template>
            </el-table-column>
            <el-table-column
              min-width="200"
              label="Created By">
              <template v-slot="props">
                {{getUserDisplayName(props.row.createdBy)}}
              </template>
            </el-table-column>
            <el-table-column
              width="90"
              fixed="right"
              label="Actions">
              <template v-slot="props">
                <p-button type="success" size="sm" icon>
                  <i class="fa fa-eye" @click="viewInvoiceDetails(props.row)"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {getTableHeight, notifyError, setIndexColumnWidth} from 'src/utilities/utils'
import Constants from 'src/utilities/constants'
import PSwitch from 'src/components/UIComponents/Switch.vue'
import PButton from 'src/components/UIComponents/Button.vue'
import Permissions from 'src/utilities/permissions'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {OK} from 'http-status-codes'
import {sync} from 'vuex-pathify'

export default {
  components: {
    PButton,
    PSwitch,
    vSelect
  },
  computed: {
    query: sync('invoices@query'),
    ...mapGetters({
      tableData: 'invoices/results',
      autocompleteResults: 'companies/autocompleteResults'
    }),
    isSearchButtonDisabled () {
      return !this.query.customerName && !this.query.refNumber && !this.query.refNumberIsNull
    },
    canRead() {
      return this.$can('read', Permissions.INVOICES)
    },
    indexColumnWidth() {
      return setIndexColumnWidth(this.tableData.length)
    }
  },
  data() {
    return {
      constants: Constants,
      selectedClient: null
    }
  },
  methods: {
    clear() {
      this.$validator.pause()
      this.$store.commit('invoices/resetQuery')
      this.$store.commit('invoices/resetResults')
      this.selectedClient = null
      setTimeout(this.resumeValidation, Constants.TIME.MILLIS.QUARTER_SECOND)
    },
    resumeValidation() {
      this.$validator.resume()
    },
    viewInvoiceDetails(invoice) {
      this.$eventHub.$emit('show-modal-1', 'Invoice', invoice, '90%')
    },
    maybeClearInvoiceNumber() {
      if (this.query.refNumber && this.query.refNumberIsNull) {
        this.$store.set('invoices/query@refNumber', null)
      }
    },
    setClient(client) {
      this.$store.set('invoices/query@customerName', null)
      if (client) {
        this.$store.set('invoices/query@customerName', client.name)
      }
    },
    async searchSubmit() {
      if (await this.$validator.validateAll()) {
        const response = await this.$store.dispatch('invoices/fetchResults')

        if (OK === response.status) {
          if (response.data.length === 0) {
            this.$eventHub.$emit('show-modal-1', 'No Results Found', null, '500px')
          }
        } else {
          notifyError(this, 'Failed to execute invoice search.')
          console.error('Invoice Search Error', JSON.parse(JSON.stringify(response)))
        }
      }
    },
    getUserDisplayName(userId) {
      return this.$store.getters['users/displayName'](userId)
    },
    tableHeight(buffer) {
      return getTableHeight(buffer)
    }
  },
  beforeMount() {
    this.$store.cache.dispatch('companies/fetchActiveForAutocomplete')
  },
  mounted() {
    this.clear()
  }
}
</script>
<style scoped>
.card .card-footer button {
  margin-bottom: 15px;
}

.card .card-footer .btn-clear {
  margin-right: 12px;
}
</style>
